export default __webpack_public_path__ + "static/media/21.3e731be2.jpg";